const sk = {
    'EXCESSIVE': 'NADMERNÁ',
    'CRITICAL': 'KRITICKÁ',
    'NORMAL': 'NORMÁLNA',
    'Current occupancy:': 'Aktuálna zaľudnenosť:',
    'persons': 'ľudí',
    'shoppers in store': 'zákazníkov práve nakupuje',
    'Missing data': 'Chýbajúce dáta',
    'Daily trend:': 'Vývoj počas dňa:',
    'Show traffic lights': 'Otvoriť semafor',
    'Set current occupancy': 'Zadať aktuálnu zaľudnenosť',
    'Number of persons in store': 'Počet ľudí na prevádzke',
    'Submit': 'Nastaviť',
    'Cancel': 'Zrušiť',
    'Occupancy was set to {0}.': 'Zaľudnenosť bola zmenená na {0}.',
    'Close': 'Zavrieť',
    'Maximum capacity ({0}) reached.': 'Dosiahnutá maximálna kapacita ({0}).',
    'Current occupancy: {0}/{1}': 'Aktuálna zaľudnenosť: {0}/{1}',
    'Current occupancy: {0}': 'Aktuálna zaľudnenosť: {0}',
    'ENTER': 'VSTÚPTE',
    '{0} person(s) may enter.': 'Môže vstúpiť: {0} ľudí.',
    'Wait, please.': 'Čakajte, prosím.',
    'STOP': 'STOP',
    'CLOSED': 'ZATVORENÉ',
    'Language': 'Zmeniť jazyk',
    'Enter': 'Vstúpte',
    'Stop': 'Stop',
    'Closed': 'Zatvorené',
    'CURRENT OCCUPANCY': 'AKTUÁLNA ZAĽUDNENOSŤ',
    'PEOPLE MAY ENTER 1': 'ČLOVEK MÔŽE VSTÚPIŤ',
    'PEOPLE MAY ENTER 2': 'ĽUDIA MÔŽU VSTÚPIŤ',
    'PEOPLE MAY ENTER 5': 'ĽUDÍ MÔŽE VSTÚPIŤ',
    'The Occupancy\nlimit will be\nreached soon.': 'Limit zaľudnenosti\nbude čoskoro\ndosiahnutý.',
    'Wait, please\nMaximum Capacity\nwas reached.': 'Počkajte prosím,\nbola dosiahnutá\nmaximálna kapacita.',
};

const de = {
    'EXCESSIVE': 'ÜBERSCHREITUNG',
    'CRITICAL': 'KRITISCH',
    'NORMAL': 'NORMAL',
    'Current occupancy:': 'Aktuelle Besucherzahl:',
    'persons': 'personen',
    'shoppers in store': 'besucher im Laden',
    'Missing data': 'Keine Daten verfügbar',
    'Daily trend:': 'Tagesverlauf:',
    'Show traffic lights': 'Anzeige der Ampelsteuerung',
    'Set current occupancy': 'Festlegung der Besucherzahl',
    'Number of persons in store': 'Anzahl von Personen im Laden:',
    'Submit': 'Festlegen',
    'Cancel': 'Abbrechen',
    'Occupancy was set to {0}.': 'Die Besucherzahl wurde festgelegt auf {0}.',
    'Close': 'Schließen',
    // 'Maximum capacity ({0}) reached.': 'Die maximale Besucherzahl wurde erreicht {0}.',
    'Maximum capacity ({0}) reached.': 'Im Moment befinden sich zu viele Besucher im Laden.',
    // 'Current occupancy: {0}/{1}': 'Aktuelle Besucherzahl: {0}/{1}',
    'Current occupancy: {0}/{1}': 'Herzlich Willkommen!',
    'Current occupancy: {0}': 'Herzlich Willkommen!',
    'ENTER': 'Bitte treten Sie ein! ',
    // '{0} person(s) may enter.': '{0} Personen dürfen eintreten.',
    '{0} person(s) may enter.': '',
    'Wait, please.': '',
    'STOP': 'Bitte warten Sie!',
    'CLOSED': 'GESCHLOSSEN',
    'Language': 'Sprache',
    'Enter': 'Bitte treten\nSie ein!',
    'Stop': 'Bitte warten Sie!',
    'Closed': 'Geschlossen',
    'CURRENT OCCUPANCY': 'AKTUELLE BESUCHERZAHL',
    'PEOPLE MAY ENTER 1': '',
    'PEOPLE MAY ENTER 2': '',
    'PEOPLE MAY ENTER 5': '',
    'The Occupancy\nlimit will be\nreached soon.': '',
    'Wait, please\nMaximum Capacity\nwas reached.': '',
};

const cz = {
    'EXCESSIVE': 'NADMĚRNÝ',
    'CRITICAL': 'KRITICKÝ',
    'NORMAL': 'NORMÁLNÍ',
    'Current occupancy:': 'Aktuální obsazenost:',
    'persons': 'osob',
    'shoppers in store': 'nakupující v obchodě',
    'Missing data': 'Chybějící data',
    'Daily trend:': 'Denní trend',
    'Show traffic lights': 'Zobrazit semafory',
    'Set current occupancy': 'Nastavit aktuální obsazenost',
    'Number of persons in store': 'Počet osob obchodě',
    'Submit': 'Potvrdit',
    'Cancel': 'Zrušit',
    'Occupancy was set to {0}.': 'Obsazenost byla nastavena na {0}.',
    'Close': 'Zavřít',
    'Maximum capacity ({0}) reached.': 'Bylo dosaženo maximální kapacity ({0}).',
    'Current occupancy: {0}/{1}': 'Aktuální obsazenost: {0}/{1}',
    'Current occupancy: {0}': 'Aktuální obsazenost: {0}',
    'ENTER': 'VSTUPTE',
    '{0} person(s) may enter.': 'Může vstoupit {0} osob.',
    'Wait, please.': 'Čekejte prosím.',
    'STOP': 'STOP',
    'CLOSED': 'ZAVŘENO',
    'Language': 'Jazyk',
    'Maximum capacity reached.': 'Limit zákazníků dosažen.',
    'Enter': 'Vstupte',
    'Stop': 'Stop',
    'Closed': 'Zavřeno',
    'CURRENT OCCUPANCY': 'AKTUÁLNÍ OBSAZENOST',
    'PEOPLE MAY ENTER 1': 'OSOBA MŮŽE VSTOUPIT',
    'PEOPLE MAY ENTER 2': 'OSOBY MOHOU VSTOUPIT',
    'PEOPLE MAY ENTER 5': 'OSOB MŮŽE VSTOUPIT',
    'The Occupancy\nlimit will be\nreached soon.': 'Limit obsazenosti\nbude brzy dosažen.',
    'Wait, please\nMaximum Capacity\nwas reached.': 'Počkejte prosím,\nbylo dosaženo\nmaximální kapacity.',
}

const hu = {
    'EXCESSIVE': 'MEGTELT',
    'CRITICAL': 'KRITIKAI',
    'NORMAL': 'NORMÁL',
    'Current occupancy:': 'Jelenlegi foglaltság:',
    'persons': 'személy',
    'shoppers in store': 'vásárlók az üzletben',
    'Missing data': 'Hiányzó adatok',
    'Daily trend:': 'Napi trend',
    'Show traffic lights': 'Mutasd a közlekedési lámpákat',
    'Set current occupancy': 'Az aktuális foglaltság beálítása',
    'Number of persons in store': 'Személyek száma az üzletben',
    'Submit': 'Megerősítés',
    'Cancel': 'Töröl',
    'Occupancy was set to {0}.': 'A foglaltság állítva {0}.',
    'Close': 'Bezázni',
    'Maximum capacity ({0}) reached.': 'A biztonságos távolságtartás érdekében, kérem várjon amíg a kijelző zöldre vált és a belépés engedélyezett!',
    'Current occupancy: {0}/{1}': 'Jelenlegi foglaltság: {0}/{1}',
    'Current occupancy: {0}': 'Jelenlegi foglaltság: {0}',
    'ENTER': 'Belépés engedélyezve',
    '{0} person(s) may enter.': '{0} személy beléphet.',
    'Wait, please.': '',
    'STOP': 'STOP',
    'CLOSED': 'ZÁRVA',
    'Language': 'Nylev',
    'Enter': 'Belépés\nengedélyezve',
    'Stop': 'Stop',
    'Closed': 'Zárva',
    'CURRENT OCCUPANCY': 'JELENLEGI FOGLALTSÁG',
    'PEOPLE MAY ENTER 1': 'SZEMÉLY BELÉPHET',
    'PEOPLE MAY ENTER 2': 'SZEMÉLY BELÉPHET',
    'PEOPLE MAY ENTER 5': 'SZEMÉLY BELÉPHET',
    'The Occupancy\nlimit will be\nreached soon.': 'A foglaltsági limit\nelérése várható.',
    'Wait, please\nMaximum Capacity\nwas reached.': 'Kérem várjon!\nMaximális belépési\nkapacitás elérve.',
}

const hr = {
    'EXCESSIVE': 'PREKOMJERNO',
    'CRITICAL': 'KRITIČNO',
    'NORMAL': 'NORMALNO',
    'Current occupancy:': 'Trenutna popunjenost:',
    'persons': 'osobe',
    'shoppers in store': 'posjetitelji u trgovini',
    'Missing data': 'Nedostatni podaci',
    'Daily trend:': 'Dnevni trend:',
    'Show traffic lights': 'Prikaz semafora',
    'Set current occupancy': 'Postavite razinu popunjenosti',
    'Number of persons in store': 'Broj osoba u trgovini',
    'Submit': 'Predati',
    'Cancel': 'Otkazati',
    'Occupancy was set to {0}.': 'Popunjenost je postavljena na {0}.',
    'Close': 'Zatvoriti',
    'Maximum capacity ({0}) reached.': 'Dosegnut maksimum ({0}).',
    'Current occupancy: {0}/{1}': 'Trenutna popunjenost: {0}/{1}',
    'Current occupancy: {0}': 'Trenutna popunjenost: {0}',
    'ENTER': 'UĐITE. Dobrodošli !!!',
    '{0} person(s) may enter.': '{0} osoba može ući.',
    'Wait, please.': 'Molim pričekajte.',
    'STOP': 'Stop.',
    'CLOSED': 'ZATVORENO',
    'Language': 'Jezik',
    'Enter': 'UĐITE.\nDobrodošli !!!',
    'Stop': 'Stop',
    'Closed': 'Zatvoreno',
    'CURRENT OCCUPANCY': 'TRENUTNA POPUNJENOST',
    'PEOPLE MAY ENTER 1': '',
    'PEOPLE MAY ENTER 2': '',
    'PEOPLE MAY ENTER 5': '',
    'The Occupancy\nlimit will be\nreached soon.': '',
    'Wait, please\nMaximum Capacity\nwas reached.': '',
};

const translations = {
    'sk': sk,
    'cz': cz,
    'de': de,
    'hu': hu,
    'hr': hr,
};

// First, checks if it isn't implemented yet.
if (!String.prototype.format) {
    String.prototype.format = function (args) {
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
                ? args[number]
                : match
                ;
        });
    };
}

function translate(language, text, attributes=[]) {
    if (language in translations) {
        if (text in translations[language]) {
            return translations[language][text].format(attributes);
        }
    }
    return text.format(attributes);
}

module.exports = translate;